import React from 'react';
import Header from '../layout/header/Header';

function About() {
  return (
    <React.Fragment>
      <Header />
      <main className="main">
        <div className="wrapper main__wrapper">
          <div className="main__content">
            <h2 className="main__title">About Us</h2>
          </div>
        </div>
      </main>
    </React.Fragment>
  );
}

export default About;
